export default __webpack_public_path__ + "static/media/1800.c82c121b.png";